import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, Grid, IconButton, Paper, TextField, ThemeProvider, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../../Components/RtlProvider"
import '../../../Styles/react-tagsinput.css'
import { ContextNotification, severitys } from "../../../App";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import FlightCompensationApi from "../../../api/FlightCompensationApi";
import helper from "../../../helper";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import staticData from "../../../data/StaticData";
import { DataGrid } from "@mui/x-data-grid";
import ConfirmationDialog from "../../../Components/ConfirmationDialog";
import { MdDelete,   MdEditSquare } from "react-icons/md";
import CustomTitle from "../../../Components/CustomTitle";

const EditAirLineAgeGroupRate = ({ row, Refresh }) => {
    const [submitLoading, setSubmitLoading] = useState(false);
    const { setOpen } = useContext(ContextNotification);
    const customization = useSelector((state) => state.customization);
    const [isloading,setIsLoading]=useState(false);
    const [rows,setRows]=useState([]);
    const schema = yup.object().shape({
        ageGroupID: yup.string().required(' گروه سنی را مشخص نمائید'),
        ticketPrice: yup.number().required(' هزینه بلیط را وارد نمائید'),
    });
            const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
        
                resolver: yupResolver(schema),
            });
const Columns=[
 { field: "ageTypeName", headerName: "گروه سنی" ,width:'150'},
  { field: "ticketPrice", headerName: "مبلغ بلیط " ,width:'150'}
];
Columns.push({
    field: "ویرایش", renderCell: (cellValues) => {
      return (
        <IconButton
        disabled={isloading} 
        sx={{color:'#c70c05c2'}}
          onClick={() => {
            handleOpenEdit(cellValues.row)}}><MdEditSquare />
        </IconButton>
      )
    }
  });
Columns.push({
    field: "حذف", renderCell: (cellValues) => {
      return (
        <IconButton
        disabled={isloading} 
        sx={{color:'#c70c05c2'}}
          onClick={() => {
            handleOpenDelete(cellValues.row)}}><MdDelete/>
        </IconButton>
      )
    }
  });
 const resetForm=()=>{
   setValue("ageGroupID",null);
   setValue("ticketPrice",null);
    setOpenDelete(false);
    setDeleteData(null);
    setSelectedAgeGroupRate(null);
 }

  ///delete/////////////////////////////////////
  const [openDelete,setOpenDelete]=useState(false);
  const[deleteDate,setDeleteData]=useState(null);
  const handleOpenDelete = (data) => {
    setOpenDelete(true);
    setDeleteData(data);
  };
  const handleDeleteRow=()=>{
    setIsLoading(true);
FlightCompensationApi.deleteAirLineAgeGroupRate(deleteDate.id).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            setOpen({ IsEnable: true, Message: 'سطر مورد نظر با موفقیت حذف شد', severity: severitys.success });
            resetForm();
            Refresh();
          }
          else {
            setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });

          }

        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
        }

      }).catch(err => {

        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }

      }).finally(() => { setIsLoading(false) });
    }
////////Edit/////////////////////////
const [selectedAgeGroupRate,setSelectedAgeGroupRate]=useState(null);
 const handleOpenEdit=(data)=>{
    if(selectedAgeGroupRate?.id===data.id)
    {
setSelectedAgeGroupRate(null); 
   setValue("ageGroupID",null);
   setValue("ticketPrice",null);
    }
    else
    {
setSelectedAgeGroupRate(data); 
   setValue("ageGroupID",String(data.ageType));
   setValue("ticketPrice",String(data.ticketPrice));
    }
   
 }

////////////////////////
        useEffect(() => {
 setValue("ageGroupID",null);
   setValue("ticketPrice",null);
   setRows(row.airLineAgeGroupRateInfo);
    }, [row]);

    const DoSave = () => {
        var ageGroupID = null;
        if (watch("ageGroupID"))
            ageGroupID= parseInt(watch("ageGroupID"))
        var ticketPrice = null;
        if (watch("ticketPrice"))
            ticketPrice = parseInt(watch("ticketPrice"))
        const data = {
            'ageType': ageGroupID,
            'ticketPrice':ticketPrice,
        }
        setSubmitLoading(true);

        if (selectedAgeGroupRate === null)//add mode
        {
            FlightCompensationApi.AddAirLineAgeGroupRate(row?.id, data).then(res => {
                if (res.status === 200) {
                    if (res.data.success) {
                        setOpen({ IsEnable: true, Message: 'هزینه بلیط با موفقیت افزوده شد', severity: severitys.success });
                        resetForm();
                        Refresh();
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                    }
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }

            }).catch(err => {

                if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }

            }).finally(() => { setSubmitLoading(false) });
        }
        else {
            FlightCompensationApi.UpdateAirLineAgeGroupRate(selectedAgeGroupRate?.id, data).then(res => {
                if (res.status === 200) {
                    if (res.data.success) {
                        setOpen({ IsEnable: true, Message: 'ویرایش هزینه بلیط با موفقیت انجام شد', severity: severitys.success });
                        resetForm();
                        Refresh();
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });

                    }

                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }

            }).catch(err => {

                if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }

            }).finally(() => { setSubmitLoading(false) });
        }

    }

const handleChangeTicketPrice=(value)=>{
   if ((value!==null) && (parseInt(value) > 0)) {
     setValue("ticketPrice",value);
   }
  else
  {
    setValue("ticketPrice",null);
  }
}

  
    return (
        <Box sx={{ m: 2 }}>
            <ThemeProvider theme={customtheme(customization)}>
                <RtlProvider>
                  <CustomTitle title={'هزینه بلیط بازای هر گروه سنی'} icon={null} />
                    <form onSubmit={handleSubmit(DoSave)}>
                        <Grid container spacing={1}>
                            <Grid item md={4.5}  xs={7.5}>
                                <RHFAutocomplete
                                    control={control}
                                    disabled={(selectedAgeGroupRate!==null)}
                                    options={staticData.ageGroup}
                                    name="ageGroupID"
                                    placeholder="گروه سنی"
                                    style={{
                                        border: "none",
                                        padding: 0
                                    }}
                                />
                                 <p className="error">{errors.ageGroupID?.message}</p>
                            </Grid>
                            <Grid item md={3.5} xs={7.5}>
                                <TextField
                                type="number"
                                label=" هزینه بلیط "
                                    {...register("ticketPrice")}
                                    onChange={(event)=>{handleChangeTicketPrice(event.target.value);}}
                                    fullWidth></TextField>
                                     <p className="error">{errors.ticketPrice?.message}</p>
                            </Grid>
                            <Grid item md={2} xs={7.5}>
                                <Button type="submit"  disabled={submitLoading} sx={{ mt: 1 }} variant="contained" color="primary" fullwidth >
                                    <BeatLoading loading={submitLoading} color={"#e65100"} /> {(selectedAgeGroupRate!==null) ? 'ویرایش' : 'ثبت'}</Button>
                            </Grid>
                        </Grid>
                        <Paper sx={{mt:2,width: "100%", height: "500px"}}>
          <DataGrid
        rows={rows}
        columns={Columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 50,
            },
          },
        }}
        pageSizeOptions={[25, 50, 100]}
        checkboxSelection={false}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnSelector
        loading={isloading}
         sx={{
          backgroundColor: '#F1F1E8', // Set your desired background color    
          '& .MuiDataGrid-columnHeaders > div[role="row"]': {
            color:'#F1F1E8!important',
        backgroundColor: '#50a193ff!important',
      },
        }}
      />
      </Paper >
       <ConfirmationDialog
        open={openDelete}
        handleClose={() => setOpenDelete(false)}
        deleteFunction={handleDeleteRow}
      />
                    </form>
                </RtlProvider>
            </ThemeProvider>
        </Box >
    )
}
export default EditAirLineAgeGroupRate